<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="700"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>運搬情報の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- 引渡担当者 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`deliver_staff`"
                  :class="forms.manifest_type === 'dxe_form' ? 'requiredMark' : '' "
                  :rules="{ required: forms.manifest_type === 'dxe_form', max: 12 }"
                  name="引渡担当者"
                >
                  <v-combobox
                    v-model="forms.deliver_staff"
                    :error-messages="errors"
                    :items="deliverers"
                    :return-object="false"
                    dense
                    label="引渡担当者"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>引渡担当者</span>
                      <span class="ml-1">
                        ({{ forms.deliver_staff?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-combobox>
                </validation-provider>
              </v-col>
              <!-- /引渡担当者 -->
              <!-- 登録担当者 -->
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`register_staff`"
                  name="登録担当者"
                  rules="max:12"
                >
                  <v-combobox
                    v-model="forms.register_staff"
                    :error-messages="errors"
                    :items="registers"
                    :return-object="false"
                    dense
                    label="登録担当者"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>登録担当者</span>
                      <span class="ml-1">
                        ({{ forms.register_staff?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-combobox>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /登録担当者 -->
            <!-- 運搬担当者 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ max: 12 }"
                  name="運搬担当者"
                >
                  <v-combobox
                    v-model="forms.transport_user_name"
                    :error-messages="errors"
                    :items="drivers"
                    :return-object="false"
                    clearable
                    dense
                    hide-details="auto"
                    item-value="text"
                    label="運搬担当者"
                    outlined
                    persistent-placeholder
                    @click:clear="transportUserClearClickEvent"
                    @change="transportUserChangeEvent"
                  >
                    <template v-slot:label>
                      <span>運搬担当者</span>
                      <span class="ml-1">
                        ({{ forms.transport_user_name?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-combobox>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /運搬担当者 -->
            <!-- 運搬方法・車両番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="運搬方法"
                >
                  <v-select
                    v-model="forms.transportation_id"
                    :items="transportations"
                    :error-messages="errors"
                    clearable
                    dense
                    hide-details="auto"
                    label="運搬方法"
                    outlined
                    persistent-placeholder
                  ></v-select>
                </validation-provider>
              </v-col>

              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="車両番号"
                  rules="max:15"
                >
                  <v-combobox
                    v-model="forms.vehicle_number"
                    :error-messages="errors"
                    :items="vehicles"
                    :return-object="false"
                    :clearable="true"
                    dense
                    hide-details="auto"
                    item-text="number"
                    item-value="number"
                    label="車両番号"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>車両番号</span>
                      <span class="ml-1">
                        ({{ forms.vehicle_number?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-combobox>
                </validation-provider>

              </v-col>
            </v-row>
            <!-- /運搬担当者・車両番号 -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditTransportLocationDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestId: {
      type: Number,
      default: () => null,
    },
    transportations: {
      type: Array,
      default: () => []
    },
    drivers: {
      type: Array,
      default: () => []
    },
    vehicles: {
      type: Array,
      default: () => []
    },
    deliverers: {
      type: Array,
      default: () => []
    },
    registers: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      /** 運搬方法 */
      forms: {
        manifest_type: null,
        deliver_staff: null,
        register_staff: null,
        transportation_id: null,
        transport_user_id: null,
        transport_user_name: null,
        vehicle_number: null,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementTransportLocation', {
      fetchCollectionReport: 'edit',
      updateCollectionReport: 'update',
    }),
    ...mapActions("DriverManifestManagementVerifyTransportLocation", {
      verifyTransportLocation: "update",
    }),
    setVariable () {
      this.fetchCollectionReport({ id: this.manifestId }).then((content) => {
        console.log(content)
        this.forms = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      const $self = this;
      this.$refs.observer.validate().then((result) => {
        if(result) {
          setTimeout($self.sendRegistrationInformation, 500);
        }
      })
    },
    /**
     * 運搬担当者 チェンジイベント
     * @param item { String }
     */
    transportUserChangeEvent (item) {
      const transportUser = this.drivers.find( (v) => v.text.replace(/\s+/g,'') === item.replace(/\s+/g,''))
      if (transportUser) {
        this.forms.transport_user_id = transportUser.value
      } else {
        this.forms.transport_user_id = null
      }
    },
    transportUserClearClickEvent () {
      this.forms.transport_user_id = null
      this.forms.transport_user_name = null
    },
    sendRegistrationInformation () {
      const params = this.buildParams();
      this.verifyTransportLocation({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      const params = this.buildParams()
      this.updateCollectionReport({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      return {
        deliver_staff: this.forms.deliver_staff,
        register_staff: this.forms.register_staff,
        transportation_id: this.forms.transportation_id,
        transport_user_id: this.forms.transport_user_id,
        transport_user_name: this.forms.transport_user_name,
        vehicle_number: this.forms.vehicle_number
      }
    },
  }
}
</script>

<style scoped>

</style>
